module.exports = __webpack_public_path__ + "static/media/birthday-party-grid-1.2127f813.jpg";